import { SidePanel } from '@/shared/ui/SidePanelWrapper';
import { SidePanelContainerProps } from './SidePanelContainer.types';
import { useTranslation } from 'react-i18next';

export const SidePanelContainer = ({ closeSidePanel, type }: SidePanelContainerProps) => {
  const { t } = useTranslation('common');

  if (type === 'widget') {
    // Render generic widget host which handles EmailFlow special-case internally
    return <SidePanel.Widget />;
  }

  return (
    <SidePanel title={t('components.sidePanelContainer.noWidgetFound')} onClose={closeSidePanel}>
      <div className="flex h-full flex-col items-center justify-center">
        <p className="text-body-md">{t('components.sidePanelContainer.oopsNoWidgetFound')}</p>
        <p className="text-body-md">
          {t('components.sidePanelContainer.pleaseSelectADifferentAgent')}
        </p>
      </div>
    </SidePanel>
  );
};
